import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopanchganicab() {



const cardData = {
  keyword: " Mumbai to Panchgani Cab",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Panchgani cab services, ensuring a smooth and scenic journey to one of Maharashtra’s most popular hill stations. Our professional drivers, well‑maintained vehicles, and punctual pickups make traveling from Mumbai to Panchgani stress‑free and enjoyable. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and groups. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for your Mumbai to Panchgani cab travel.",

topPlaces: [
  {
    title: "Table Land",
    description: "Table Land is one of Panchgani’s most famous attractions, known as the second‑longest mountain plateau in Asia. Travelers from Mumbai can enjoy a cab ride to this vast open plateau offering panoramic views of the surrounding valleys, hills, and sunrise or sunset vistas. The area is ideal for photography, leisurely walks, picnics, and star gazing on clear nights, making it a perfect stop for nature lovers."
  },
  {
    title: "Sydney Point",
    description: "Sydney Point offers breathtaking panoramic views of the Dhom Dam backwaters and the Krishna Valley. Cab travelers from Mumbai to Panchgani can visit this viewpoint to enjoy fresh hill station air, scenic landscapes, and peaceful surroundings. It’s a popular spot for photography, quiet relaxation, and spending quality time amidst nature."
  },
  {
    title: "Panchgani Table Land Sunset Point",
    description: "The Panchgani Table Land Sunset Point is a must‑visit spot for travelers seeking spectacular sunset views. Visitors arriving by cab from Mumbai can watch the golden hues of the sun setting over the plateau’s expansive landscape. The place is perfect for capturing memorable photos, enjoying peaceful moments, and experiencing Panchgani’s cool mountain breeze."
  },
  {
    title: "Devil’s Kitchen",
    description: "Devil’s Kitchen is an intriguing geological formation located on the Table Land plateau, featuring narrow winding passages and scenic rock structures. Cab travelers from Mumbai can explore this unique spot and enjoy the thrill of walking through the natural rock corridors. The area also offers beautiful views of the surrounding hills and valleys."
  },
  {
    title: "Parsi Point",
    description: "Parsi Point is a picturesque viewpoint offering stunning vistas of the Krishna Valley and the Dhom Dam backwaters. Travelers from Mumbai can take a cab to Panchgani and visit Parsi Point for panoramic views, picnics, and photography. The location’s elevated setting makes it ideal for watching sunsets, enjoying nature walks, and relaxing amidst greenery."
  },
  {
    title: "Karla Caves",
    description: "The Karla Caves are ancient Buddhist rock‑cut cave complexes near Panchgani that date back over two thousand years. Travelers using a cab from Mumbai can explore these historic caves, admire ancient carvings, and learn about Buddhist history and architecture. The caves also offer scenic views of the surrounding Western Ghats."
  },
  {
    title: "Rajpuri Caves",
    description: "Rajpuri Caves are another set of ancient rock‑cut cave temples near Panchgani, known for their historic significance and serene surroundings. Cab travelers from Mumbai can visit these caves to enjoy the peaceful ambiance, explore unique rock formations, and capture photographs of the scenic environment."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a picturesque waterfall near Panchgani, especially striking during the monsoon season when the surrounding hills are lush and green. Travelers arriving by cab can take a short walk to the waterfall, listen to the roar of cascading water, and enjoy the scenic beauty. It’s a great stop for nature lovers and photographers."
  },
  {
    title: "Dhom Dam",
    description: "Dhom Dam is a scenic reservoir surrounded by hills and valleys near Panchgani. Cab travelers from Mumbai can enjoy the panoramic views of the dam and its sparkling waters, have a picnic by the shore, or take a leisurely walk along the embankment. The location is also popular for boating and photography."
  },
  {
    title: "Mapro Garden (Mahabaleshwar)",
    description: "Mapro Garden in nearby Mahabaleshwar is a vibrant attraction known for its strawberry farms, fruit products, and scenic ambiance. Travelers from Mumbai can combine their Panchgani trip with a visit to Mapro Garden to enjoy fresh strawberry juice, jams, and other local treats. The garden’s colorful surroundings make it a pleasant stop for refreshments and leisure exploration."
  }
],



services: [
{
name: "Mumbai to Panchgani Cab Service",
description: "Mumbai to Panchgani cab service offers a relaxing and scenic journey to one of Maharashtra’s most peaceful hill stations known for its viewpoints, strawberry farms, and cool climate. This service is ideal for families, couples, and weekend travelers looking to escape the city and enjoy a refreshing getaway. The route passes through beautiful ghats and lush green landscapes, making the journey enjoyable and memorable. Professional drivers experienced in hill driving ensure safe and smooth travel throughout the trip. Customers can choose from sedan, SUV, and premium vehicles based on their travel needs and group size. Flexible pickup options from home, airport, or railway station add convenience to the journey. With transparent pricing, easy booking, and 24x7 availability, this cab service ensures a hassle-free and comfortable travel experience."
},
{
name: "Mumbai to Panchgani Taxi",
description: "Mumbai to Panchgani taxi service provides reliable and comfortable transportation for travelers planning a hill station trip. Well-maintained vehicles and experienced drivers ensure a safe journey through winding ghat roads. This service is perfect for both leisure and corporate travel with flexible timing options. Travelers can enjoy door-to-door pickup and drop without the hassle of public transport. Multiple vehicle options including sedan and SUV are available for different budgets. With affordable pricing and easy booking, this taxi service ensures a smooth and enjoyable journey."
},
{
name: "One Way Cab Mumbai to Panchgani",
description: "One way cab Mumbai to Panchgani is a cost-effective option for travelers who need a single-side drop without return charges. This service is ideal for those planning longer stays or onward travel from Panchgani. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure timely arrival and safe driving on ghat routes. Sedan and SUV options are available based on travel needs. Easy online booking and instant confirmation make it convenient for all travelers."
},
{
name: "Mumbai to Panchgani Cab Booking",
description: "Mumbai to Panchgani cab booking allows travelers to reserve their cab quickly with instant confirmation and flexible travel schedules. Customers can choose vehicle types, travel dates, and pickup locations as per their convenience. Transparent pricing ensures no hidden charges during the journey. Online booking platforms provide a hassle-free experience with secure payment options. Dedicated support is available for assistance before and during travel. It is the easiest way to plan your Panchgani trip."
},
{
name: "Mumbai to Panchgani Taxi Fare",
description: "Mumbai to Panchgani taxi fare is designed to be transparent and budget-friendly, helping travelers plan their trip efficiently. Pricing varies based on vehicle type, distance, and duration of travel. Customers receive clear cost breakdowns including tolls and driver allowances where applicable. Affordable options are available for sedan, SUV, and premium vehicles. No hidden charges ensure trust and reliability. It offers excellent value for a comfortable hill station journey."
},
{
name: "Cheap Cab Mumbai to Panchgani",
description: "Cheap cab Mumbai to Panchgani provides budget-friendly travel options without compromising on comfort and safety. This service is ideal for cost-conscious travelers who want reliable transportation at affordable rates. Economical sedan options are available for lower fares. Transparent pricing and no hidden charges make this service highly popular. Professional drivers ensure safe travel through ghat roads. It is a perfect balance of affordability and comfort."
},
{
name: "Mumbai to Panchgani Outstation Taxi",
description: "Mumbai to Panchgani outstation taxi service offers long-distance travel with comfort and reliability for hill station trips. This service is ideal for tourists and business travelers seeking a smooth journey. Vehicles are well-maintained for safety and performance on highways and ghats. Flexible pickup options and travel schedules add convenience. Travelers can choose between one way and round trip packages. It ensures a hassle-free and enjoyable travel experience."
},
{
name: "AC Cab Mumbai to Panchgani",
description: "AC cab Mumbai to Panchgani ensures a comfortable journey in air-conditioned vehicles, especially during long-distance travel. This service provides a pleasant environment inside the vehicle regardless of weather conditions. Clean interiors and well-maintained AC systems enhance passenger comfort. Suitable for families, tourists, and corporate travelers. Flexible pickup options add convenience. It guarantees a relaxing travel experience."
},
{
name: "Mumbai to Panchgani Sedan Cab",
description: "Mumbai to Panchgani sedan cab is perfect for small families and couples looking for an affordable and comfortable ride. Sedans offer smooth travel, good mileage, and comfortable seating for long-distance journeys. This option is ideal for budget-friendly travel without compromising on convenience. Professional drivers ensure safe driving throughout the route. Easy booking and flexible timing enhance the travel experience. It is one of the most preferred options."
},
{
name: "Mumbai to Panchgani SUV Taxi",
description: "Mumbai to Panchgani SUV taxi is ideal for group travel and those seeking extra comfort on hilly terrain. SUVs provide better road grip and spacious seating, making them perfect for ghat routes. This option is suitable for families, friends, and corporate groups. Drivers are experienced in hill driving ensuring safety. It offers a premium and comfortable travel experience. Ideal for long-distance and scenic trips."
}
],

tableData: [
["Mumbai to Panchgani Cab Service","Mumbai to Panchgani Taxi"],
["One Way Cab Mumbai to Panchgani","Mumbai to Panchgani Cab Booking"],
["Mumbai to Panchgani Taxi Fare","Cheap Cab Mumbai to Panchgani"],
["Mumbai to Panchgani Outstation Taxi","AC Cab Mumbai to Panchgani"],
["Mumbai to Panchgani Sedan Cab","Mumbai to Panchgani SUV Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Hill Station Travel",
    WhyChoosedescription: "Velocity Cabs offers smooth and comfortable Mumbai to Panchgani cab service, ideal for weekend getaways, family trips, and nature lovers visiting the scenic hill station."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through ghat roads and hill routes to Panchgani, ensuring safe navigation and a relaxed travel experience."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mumbai to Panchgani cab bookings. Customers receive complete fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Panchgani cab service operates 24/7. Whether you plan an early morning departure or late-night return, Velocity Cabs ensures reliable service anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and enjoyable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized travel plans for Mumbai to Panchgani trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Panchgani cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Panchgani cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Panchgani for one-way and round-trip travel." },
  { question: "How far is Panchgani from Mumbai?", answer: "The distance between Mumbai and Panchgani is approximately 250 km and the journey takes around 5 to 6 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Panchgani cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Panchgani." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Panchgani cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [

  {
    id: 1,
    name: "Mr. Sandeep Jadhav",
    feedback:
      "A refreshing hill journey from Mumbai to Panchgani with a very comfortable cab. The ride was smooth, and the scenic route made the travel experience even better.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Kulkarni",
    feedback:
      "The Mumbai to Panchgani cab trip was very pleasant. The vehicle was clean, the drive was steady, and the entire journey felt safe and well-organized.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const mumbaiPanchganiJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Panchgani Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Panchgani for a comfortable outstation trip. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Panchgani Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mumbai to Panchgani",
        "description": "Private cab from Mumbai to Panchgani for one-way travel with AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mumbai to Panchgani Cab",
        "description": "Comfortable round-trip cab service from Mumbai to Panchgani with private AC/SUV/Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};



  return (
    <div>
      

<Helmet>
  <title>Mumbai to Panchgani Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Panchgani for a comfortable outstation trip. AC, Sedan, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiPanchganiJSON)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopanchganicab;